
<template>
	<div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" align="center" ></compFormQuery>
			<compFormEdit v-else ref="relation" class="margin-layout" :formdata="getBase" v-model="formData" align="center"/>
		</compWrapper>
		<compWrapper title="操作历史" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper>
        <div class="text-right">
			<vButton v-if="!query" theme="primary" class="width-15per" @click="submit">保存</vButton>
            <vButton class="width-15per margin-left-10" @click="cancel">返回</vButton>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>
<script>

import { HttpOversizeOne, HttpOversizeSave, HttpGetLog } from "@/service/fedex";
// import { mapState, mapGetters } from "vuex";
import mixin from '../fedexcost/mixin';

export default {
	mixins:[mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading:false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			opLogList: [],
			detailList:[],
			formData: {
			}
		}
	},
	created() {
		this.query = this.type === "query";
		if (this.type == 'edit' || this.type == 'query') {
			this.getDetail()
		}
	},
	computed: {
		getBase() {
            let showquery = this.type == 'query' || this.type == 'edit'
			return [
				{
                    label: "规则名称",
                    key: "ruleName",
                    tag: "vInput",
					query: showquery,
                },
                {
					label: "规则公式",
                    key: "ruleRangeFormula",
                    tag: "vInput",
                },
			];
        },
	},
	methods: {
		async getDetail() {
            this.loading = true;
            HttpOversizeOne({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
			});
			if(this.query){
				// 请求日志的接口
				HttpGetLog({
					id:this.id,
					module:29,
				}).then(res=>{
					this.opLogList = res.data
				},err=>{
	
				})
			}
		},
		handleResponse(data={}){
			this.formData = data
		},
		submit(){
			HttpOversizeSave({
				...this.formData
			}).then(res=>{
				this.loading = false
				this.$VMessage.success(res.message)
				this.cancel()
			},err=>{
				this.loading = false
			})
		},
		cancel(){
			this.$router.push({ name: "fedexOversizeList" })
		}	
	},
}
</script>
